<template>
  <div>
    <el-popover ref="popover"
      :placement="placement"
      trigger="click"
      v-model="visiblehide">
      <div style="overflow: hidden">
        <el-tree :data="data"
          :props="props"
          node-key="nodeKey"
          accordion
          ref="popupTree"
          @current-change="currentChangeHandle"
          @node-click="checkchangeHandle"
          :highlight-current="true"
          :expand-on-click-node="true">
        </el-tree>
      </div>
    </el-popover>
    <el-input v-model="prop"
      v-popover:popover
      :readonly="true"
      :placeholder="placeholder"
      style="cursor: pointer"></el-input>
  </div>
</template>

<script>
export default {
  name: "PopupTreeInput",
  data () {
    return {
      size: "mini",
      visiblehide: false,
    };
  },
  props: {
    data: {
      type: Array,
      default: [],
    },
    props: {
      type: Object,
      default: {},
    },
    prop: {
      type: String,
      default: "",
    },
    nodeKey: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "点击选择内容",
    },
    placement: {
      type: String,
      default: "right-start",
    },
    defaultExpandAll: {
      type: Boolean,
      default: true,
    },
    currentChangeHandle: {
      type: Function,
      default: null,
    },
  },
  methods: {
    checkchangeHandle: function (e) {
      this.visiblehide = false;
    },
  },
};
</script>

<style scoped>
/deep/.el-tree-node .el-tree-node__children:last-child {
  height: auto;
  max-height: 500px;
  padding: 5px;
  /* display: flex; */
  overflow-x: auto;
  overflow-y: auto;
  white-space: nowrap;
}
</style>
